import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Iowa = () => {
  return (
    <StatePropertyTaxPage
      stateName="Iowa"
      processDescription="Property owners receive notice in spring and can file an appeal to the local Board of Review. Appeals must be filed between April 2 and April 30. The mailing date could be earlier or later, but the deadline is 30 days from date of mailing. If unresolved after informal appeal with County Appraiser, file formal appeal to Kansas Board of Tax Appeals (BOTA) with Small Claims Division for residential under $3M or Regular Division for higher value or commercial properties."
      noticeOfValueMailed="April 1"
      noticeOfValueMailedDateExplanation="Assessment notices are mailed by April 1 as required under Iowa Code § 441.23."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Iowa Code § 441.21 mandates properties be assessed as of January 1 each year. This assessment date ensures consistent property valuations across all counties in Iowa for the current tax year."
      deadlineExplanation="Property owners must file protests with the local Board of Review between April 2 and April 30. The deadline is 30 days from the date of mailing, but the window is specifically set as April 2-30 regardless of mailing date variations."
      stateStatute="https://www.legis.iowa.gov/docs/code/441.pdf"
    />
  );
};

export default Iowa;